import FamilyDialogMemberJoinFamily from '~/components/family/dialog/DialogMemberJoinFamily.vue';

export const useFamilyNewMemberNomad = () => {
  const profile = useProfileStore();
  const context = useContextStore();
  const hasData = ref<boolean>(profile.data !== null);
  const dialog = useDialogStore();
  const getNewMemberFamily = (newCode: string, previousCode: string) => {
    if (!profile.isASubscriber || profile.isParent || !hasData.value)
      return null;

    if (newCode && newCode !== previousCode) {
      return profile.family.members.find(
        (member) => member.memberId === context.memberId
      );
    }
    return false;
  };

  watch(
    () => profile.data,
    (dataTo: Profile, dataFrom: Profile) => {
      hasData.value = dataFrom !== null;
    }
  );

  watch(
    () => profile.family?.familyCode ?? null,
    (to, from) => {
      const newMemberFamily = getNewMemberFamily(to, from);
      if (newMemberFamily) {
        dialog.open(FamilyDialogMemberJoinFamily, {
          member: newMemberFamily,
        });
      }
    }
  );
};
